import graphql from './graphql';

const query = /* GraphQL */ `
  query putSignedUrl($key: String!) {
    putSignedUrl(key: $key) {
      signedUrl
    }
  }
`;

const S3putSignedUrl = async ({ key }) => graphql(query, { key }).then(({ putSignedUrl }) => putSignedUrl);

export default S3putSignedUrl;
